import React from "react";
import { useLocation, useParams } from "react-router-dom";

import "./index.scss";

import { marryData } from "../../data/navBar/vendordata";

import ChoiseCard from "../../molecules/cards/ChoiseCard";
import Choise from "../../organisms/choice/Choise";
import InspHero from "../../organisms/hero/InspHero";
import useGet from "../../customHooks/useGet/UseGet";

const InspirationDetail = () => {
  const { name } = useParams();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const { data } = useGet(`list_inspirations`);
  const Item = data?.data?.find(item=>item.title === name)


  return (
    <>
      <div className="my-5 px-5">
        <h2>{name} </h2>

        <div className="my-4 pb-4 border-top">
          <InspHero />
          <div className="row my-5">
            <div className="col-12 text-center d-flex justify-content-center">
              <div className="detail_image_container">
                <img
                  src={Item?.images[0].image}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="descrip">
        

            <p>
            {Item?.details}
            </p>
            <p>
            {/* {Item?.terms_and_conditions} */}
            </p>
            {/* <p>
              If you are not sure what fall nail color to choose for your big
              day, there are many pretty nail polish colors for you to consider.
            </p>

            <p>
              Some of the most popular fall nails colors are burgundy and
              maroon, they are subtle yet striking colors that will definitely
              add that autumn touch to your bridal look.
            </p>

            <p>
              Other popular fall wedding nails colors are dark orange and mauve,
              many brides love to go for a lilac or mauve hue instead of the
              traditional blush pink color, while a darker shade of orange will
              scream fall season, and it is also a very unique color.
            </p>
            <p>
              But if you are a bride who prefers more minimal nails and neutral
              colors but still want that fall nail color, you can't go wrong
              with a nude shade, you can also go for greyish tones if they suit
              your skin tone.
            </p>
            <p>
              If you are a bold bride, then a beautiful red color is always a
              great choice for a fall nail color.
            </p>
            <p>
              Keep in mind that the most important thing is to pick a shade that
              feels right for you, to help you out and give you some inspiration
              here are some ideas on some beautiful autumn nail colors we love:
            </p> */}
          </div>
          <div className="row">
            {Item?.images?.map((card, index) => (
              <div key={index} className="col-md-3 my-2 ">
                <div className="image_insp">
                  <img src={card.image} alt="" />
                </div>
              </div>
            ))}
          </div>
          <div className="row my-4">
            <div className="col-12 d-flex text-center d-flex justify-content-center ">
              <div className="footer-social-media-facebook d-flex justify-content-center align-items-center">
                <i class="fa-brands fa-facebook-f"></i>
              </div>
              <div className="footer-social-media-instagram d-flex justify-content-center align-items-center">
                <i class="fa-brands fa-instagram"></i>
              </div>
              <div className="footer-social-media-youtube d-flex justify-content-center align-items-center">
                <i class="fa-brands fa-youtube"></i>
              </div>
              <div className="footer-social-media-twitter d-flex justify-content-center align-items-center">
                <i class="fa-brands fa-x-twitter"></i>
              </div>
              <div className="footer-social-media-instagram d-flex justify-content-center align-items-center">
                <i class="fa fa-pinterest-p" aria-hidden="true"></i>
              </div>
              <div className="footer-social-media-facebook d-flex justify-content-center align-items-center">
                <i class="fa fa-linkedin" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div className="row my-4">
            <h3 class="my-4 py-3 font-bold border-top border-bottom w-100">Read More</h3>
            {data?.data.slice(0,3).map((card, index) => (
              <div key={index} className="col-md-3 my-2 px-1 mx-0">
                <ChoiseCard
                 img={card.images[0].image}
                 title={card.title}
                 id={id}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Choise />
    </>
  );
};

export default InspirationDetail;
